import { connect } from 'react-redux'

import showConfirmationCodeFormModal from '../ConfirmationCodeFormModal'
import InputWithConfirmComponent from './InputWithConfirm'

const stateToProps = ({ auth: { user } }, { type }) => ({
  confirmation: type === 'email' ? user.emailConfirmation : user.phoneConfirmation,
})

const dispatchToProps = {
  showConfirmationCodeFormModal,
}

export default connect(stateToProps, dispatchToProps)(InputWithConfirmComponent)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/InputWithConfirm/InputWithConfirm.container.js